import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ palette, spacing }) => ({
  title: {
    color: ({ isSelected }) => isSelected ? palette.primary.main : palette.text.secondary,
    marginBottom: spacing(1),
    position: 'relative'
  },
  steps: {
    marginBottom: spacing(1)
  },
  stepLabel: {
    color: palette.text.secondary
  }
}))
